


import React, { useState, useEffect } from "react";
import { Header } from "../../Header";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import SearchModal from './SearchModal';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import Pagination from '@mui/material/Pagination';
import { local_signage, local_url } from "../../Const";




// Keeping your existing styled components
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha('#F1F8E9', 0.9),
  '&:hover': {
    backgroundColor: alpha('#F1F8E9', 1),
  },
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  height: '40px',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 2),
    width: '100%',
    height: '24px',
  },
}));

const SearchIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(1),
  position: 'relative',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0 4px 4px 0',
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.05),
  },
}));

export const B2CSales = () => {
  const today = dayjs();
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [salesData, setSalesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [isSearching, setIsSearching] = useState(false);
  const [searchParams, setSearchParams] = useState({
    branchId: 'ALL',
    city: '',
    state: '',
    mobile: 'ALL'
  });
  const formatDateForAPI = (date) => {
    return dayjs(date).format("YYYYMMDD");
  };
  const [page, setPage] = useState(1);
  const rowsPerPage = 100;
  const [totalCount, setTotalCount] = useState(0); // State to store total count


  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const paginatedData = salesData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const totalPages = Math.ceil(totalCount / rowsPerPage);


  // Modified page change handler
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };


  const fetchTotalCount = async (searchCriteria = {}) => {
    const token = localStorage.getItem('AuthorizationToken');
    if (!token) {
      setError('Authorization token is missing.');
      return;
    }

    try {
      const formattedFromDate = formatDateForAPI(fromDate);
      const formattedToDate = formatDateForAPI(toDate);
      const startRecord = (page - 1) * rowsPerPage + 1;
      const queryParams = new URLSearchParams({
        Mobile: searchCriteria.mobileNumber || searchParams.mobile,
        SalesChannel: 'ALL',
        BranchId: searchCriteria.branchId || searchParams.branchId,
        CityID: searchCriteria.city || searchParams.city || 'ALL',
        StartDate: formattedFromDate,
        EndDate: formattedToDate,
  StartRecord: "1",
        RowsCount: "100",
      });

      const response = await fetch(
        `${local_signage}/api/v1/b2csalecount?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch total count');
      }

      const data = await response.json();
      setTotalCount(data[0].cnt); // Set the total count
    } catch (error) {
      console.error('Fetch error:', error);
      setError('Failed to fetch total count. Please try again.');
    }
  };

  const handleSubmit = () => {
    setPage(1); // Reset to first page when submitting new search
    fetchData(1, searchParams);
  };


  const fetchData = async (pageNumber = 1, searchCriteria = {}) => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem('AuthorizationToken');
    if (!token) {
      setError('Authorization token is missing.');
      setLoading(false);
      return;
    }

    try {
      const formattedFromDate = formatDateForAPI(fromDate);
      const formattedToDate = formatDateForAPI(toDate);
      const startRecord = (pageNumber - 1) * rowsPerPage + 1;

      // First fetch the total count
      const countQueryParams = new URLSearchParams({
        Mobile: searchCriteria.mobileNumber || searchParams.mobile,
        SalesChannel: 'ALL',
        BranchId: searchCriteria.branchId || searchParams.branchId,
        CityID: searchCriteria.city || searchParams.city || 'ALL',
        StartDate: formattedFromDate,
        EndDate: formattedToDate,
        StartRecord: "1",
        RowsCount: "100",
      });

      const countResponse = await fetch(
        `${local_signage}/api/v1/b2csalecount?${countQueryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!countResponse.ok) {
        throw new Error('Failed to fetch total count');
      }

      const countData = await countResponse.json();
      setTotalCount(countData[0].cnt);

      // Then fetch the paginated data
      const dataQueryParams = new URLSearchParams({
        Mobile: searchCriteria.mobileNumber || searchParams.mobile,
        SalesChannel: 'ALL',
        BranchId: searchCriteria.branchId || searchParams.branchId,
        CityID: searchCriteria.city || searchParams.city || 'ALL',
        StartDate: formattedFromDate,
        EndDate: formattedToDate,
        StartRecord: startRecord.toString(),
        RowsCount: rowsPerPage.toString(),
      });

      const dataResponse = await fetch(
        `${local_signage}/api/v1/b2csalesreport?${dataQueryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!dataResponse.ok) {
        throw new Error('Failed to fetch sales data');
      }

      const salesData = await dataResponse.json();
      setSalesData(salesData);
    } catch (error) {
      console.error('Fetch error:', error);
      setError('Failed to fetch data. Please try again.');
    } finally {
      setLoading(false);
    }
  };




  const fetchSalesData = async (searchCriteria = {}) => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem('AuthorizationToken');
    if (!token) {
      setError('Authorization token is missing.');
      setLoading(false);
      return;
    }

    try {
      const formattedFromDate = formatDateForAPI(fromDate);
      const formattedToDate = formatDateForAPI(toDate);

      // Calculate StartRecord based on the current page and rows per page
      const startRecord = (page - 1) * rowsPerPage + 1;

      const queryParams = new URLSearchParams({
        Mobile: searchCriteria.mobileNumber || searchParams.mobile,
        SalesChannel: 'ALL',
        BranchId: searchCriteria.branchId || searchParams.branchId,
        CityID: searchCriteria.city || searchParams.city || 'ALL',
        StartDate: formattedFromDate,
        EndDate: formattedToDate,
        StartRecord: startRecord, // Add StartRecord for pagination
        RowsCount: rowsPerPage, // Add RowsCount for pagination
      });

      const response = await fetch(
        `${local_signage}/api/v1/b2csalesreport?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch sales data');
      }

      const data = await response.json();
      setSalesData(data);
    } catch (error) {
      console.error('Fetch error:', error);
      setError('Failed to fetch sales data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

//   // Fetch total count and sales data when the component mounts or search criteria change
//  useEffect(() => {
//     fetchData(page, searchParams);
//   }, [page, fromDate, toDate, searchParams]);



  const handleSearch = async (searchCriteria) => {
    setIsSearching(true);
    try {
      setSearchParams({
        branchId: searchCriteria.branchId || 'ALL',
        city: searchCriteria.city,
        state: searchCriteria.state,
        mobile: searchCriteria.mobileNumber || 'ALL'
      });
      setPage(1); // Reset to first page when searching
      await fetchData(1, searchCriteria);
      setSearchTerm(searchCriteria.customerName || '');
    } finally {
      setIsSearching(false);
      setIsSearchModalOpen(false);
    }
  };


  const handleSearchOpen = () => {
    setIsSearchModalOpen(true);
  };

  const handleSearchClose = () => {
    setIsSearchModalOpen(false);
  };



  const exportToCSV = async () => {
    setLoading(true);
    const token = localStorage.getItem('AuthorizationToken');
    
    try {
      // First, get the total count
      const formattedFromDate = formatDateForAPI(fromDate);
      const formattedToDate = formatDateForAPI(toDate);
      
      const queryParams = new URLSearchParams({
        Mobile: searchParams.mobile,
        SalesChannel: 'ALL',
        BranchId: searchParams.branchId,
        CityID: searchParams.city || 'ALL',
        StartDate: formattedFromDate,
        EndDate: formattedToDate,
        StartRecord: '1',
        RowsCount: totalCount // Fetch all records at once for export
      });
  
      const response = await fetch(
        `${local_signage}/api/v1/b2csalesreport?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (!response.ok) {
        throw new Error('Failed to fetch data for export');
      }
  
      const allData = await response.json();
  
      if (allData.length === 0) {
        alert("No data available to export.");
        return;
      }
  
      const headers = [
        "S No.",
        "Branch ID",
        "Sale ID",
        "Order ID",
        "Business Date",
        "Channel ID",
        "Customer Name",
        "Mobile",
        "Delivery Area",
        "Pincode",
        "City",
        "Total",
        "Payment Method",
        "Branch Name",
        "Total Weight",
        "Order Date",
        'Sale Cancelled'
      ];
  
      // Add headers as the first row
      const csvRows = [headers.join(",")];
  
      // Process all sales data
      allData.forEach((item, index) => {
        const row = [
          index + 1,
          item.BranchId || "-",
          item.saleid || "-",
          item.SaleOrderId || "-",
          item.businessDate
            ? new Date(item.businessDate).toLocaleDateString()
            : "-",
          item.ChannelID || "-",
          `"${(item.CustomerName || "-").replace(/"/g, '""')}"`, // Handle quotes in customer names
          item.mobile || "-",
          `"${(item.DelArea || "-").replace(/"/g, '""')}"`,
          item.Pincode || "-",
          item.City || "-",
          item.Total !== null && item.Total !== undefined
            ? `₹${item.Total}`
            : "-",
          item.PaymentMethod || "-",
          `"${(item.BranchName || "-").replace(/"/g, '""')}"`,
          item.TotalWeight || "-",
          item.OrderDate
            ? new Date(item.OrderDate).toLocaleDateString()
            : "-",
          item.IsReturnedSale || "-"
        ];
  
        csvRows.push(row.join(","));
      });
  
      // Generate CSV content with UTF-8 BOM
      const csvContent = "\uFEFF" + csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
  
      // Create download link
      const link = document.createElement("a");
      link.href = url;
      const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "_");
      link.download = `sales_report_${timestamp}.csv`;
  
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      // Cleanup
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  const validateDateRange = (newFromDate, newToDate) => {
    const maxDays = 90; // Maximum allowed range in days
    const daysDifference = dayjs(newToDate).diff(dayjs(newFromDate), "day");
    if (daysDifference > maxDays) {
      alert(`The date range cannot exceed ${maxDays} days.`);
      return false;
    }
    return true;
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
    // Automatically adjust the toDate if it's out of range
    if (dayjs(newDate).add(40, 'day').isBefore(toDate)) {
      setToDate(dayjs(newDate).add(40, 'day'));
    }
  };

  const handleToDateChange = (newDate) => {
    setToDate(newDate);
  };


  return (
    <>
      <Header />
      <div className="customer-container">
        <div className="customer-filters-container">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From Date"
                  value={fromDate}
                  onChange={handleFromDateChange}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      sx: {
                        backgroundColor: "#F1F8E9",
                        "& .MuiInputBase-root": { height: "40px" },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To Date"
                  value={toDate}
                  onChange={handleToDateChange}
                  minDate={fromDate} // Disable dates before the selected fromDate
                  maxDate={dayjs(fromDate).add(40, 'day')} // Disable dates after 90 days from fromDate
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      sx: {
                        backgroundColor: "#F1F8E9",
                        "& .MuiInputBase-root": { height: "40px" },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Search>
                <StyledInputBase
                  placeholder="Search customer…"
                  inputProps={{ 'aria-label': 'search' }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <SearchIconButton
                  onClick={handleSearchOpen}
                  disabled={isSearching}
                >
                  {isSearching ? (
                    <CircularProgress size={24} />
                  ) : (
                    <SearchIcon />
                  )}
                </SearchIconButton>
              </Search>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div style={{ display: 'flex', gap: '8px' }}>
              <button
        onClick={handleSubmit}
        className="customer-submit-button"
        disabled={loading}
        style={{ flex: 1 }}
      >
        Submit
      </button>
                <button
                  onClick={exportToCSV}
                  className="customer-export-button"
                  disabled={loading || salesData.length === 0}
                  style={{ flex: 1 }}
                >
                  Export
                </button>
              </div>
            </Grid>
          </Grid>
        </div>

        <SearchModal
          open={isSearchModalOpen}
          onClose={handleSearchClose}
          onSearch={handleSearch}
          initialSearchTerm={searchTerm}
        />

        <div className="customer-table-container">
          <div className="customer-table-container">
            <div className="customer-table-scroll">
              <table className="customer-table">
                <thead>
                  <tr>
                    <th>S No.</th>
                    <th>Branch ID</th>
                    <th>Sale ID</th>
                    <th>Order ID</th>
                    <th>Business Date</th>
                    <th>Order Date</th>
                    <th>Channel ID</th>
                    <th>Customer Name</th>
                    <th>Mobile</th>
                    <th>Delivery Area</th>
                    <th>Pincode</th>
                    <th>City</th>
                    <th>Total</th>
                    <th>Payment Method</th>
                    <th>Branch Name</th>
                    <th>Total Weight</th>
                    <th>Sale Cancelled</th>
                  </tr>
                </thead>
                <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="17" className="customer-loading-container">
                      <CircularProgress />
                    </td>
                  </tr>
                ) : salesData.length > 0 ? (
                  salesData.map((item, index) => (
                    <tr key={index}>
                      <td>{(page - 1) * rowsPerPage + index + 1}</td>
                        <td>{item.BranchId || "-"}</td>
                        <td>{item.saleid || "-"}</td>
                        <td>{item.SaleOrderId || "-"}</td>
                        <td>{formatDate(item.businessDate)}</td>
                        <td>{formatDate(item.OrderDate)}</td>
                        <td>{item.ChannelID || "-"}</td>
                        <td>{item.CustomerName || "-"}</td>
                        <td>{item.mobile || "-"}</td>
                        <td>{item.DelArea || "-"}</td>
                        <td>{item.Pincode || "-"}</td>
                        <td>{item.City || "-"}</td>
                        <td>₹{item.Total || "-"}</td>
                        <td>{item.PaymentMethod || "-"}</td>
                        <td>{item.BranchName || "-"}</td>
                        <td>{item.TotalWeight || "-"}</td>
                        <td>{item.IsReturnedSale || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="16" className="customer-no-data">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalCount > 0 && (
            <div className="pagination-container" style={{
              padding: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '20px'
            }}>
              <div style={{ color: '#666' }}>
                Showing {(page - 1) * rowsPerPage + 1} to {Math.min(page * rowsPerPage, totalCount)} of {totalCount} entries
              </div>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                shape="rounded"
              />
            </div>
          )}
          </div>

        </div>
      </div>
    </>
  );
};

export default B2CSales;